import React from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';

import ErrorBoundary from 'src/ErrorBoundary';

import ListingContainer from 'src/containers/ListingContainer';
import ToastContainer from 'src/containers/ToastContainer';
import TabsContainer from 'src/containers/TabsContainer';
import 'src/containers/App.scss';


const App = ({ store }) => (
  <ErrorBoundary>
    <Provider store={ store }>
      {/* eslint-disable-next-line react/jsx-no-literals */}
      <h2 styleName="header">Pracuj.pl poleca</h2>
      <ToastContainer />
      <TabsContainer />
      <ListingContainer />
    </Provider>
  </ErrorBoundary>
);

App.propTypes = {
  store: PropTypes.shape({
    dispatch: PropTypes.func.isRequired,
    getState: PropTypes.func.isRequired,
    subscribe: PropTypes.func.isRequired
  }).isRequired
};

export default App;
